// removed by extract-text-webpack-plugin
module.exports = {"receipt":"c-Receipt__receipt","header":"c-Receipt__header","head":"c-Receipt__head","icon":"c-Receipt__icon","title":"c-Receipt__title","section":"c-Receipt__section","columns":"c-Receipt__columns","column":"c-Receipt__column","row":"c-Receipt__row","value":"c-Receipt__value","item":"c-Receipt__item","orderDetailsRow":"c-Receipt__orderDetailsRow","bottomSection":"c-Receipt__bottomSection","button":"c-Receipt__button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Receipt/Receipt.scss
// module id = 555
// module chunks = 0